export default __webpack_public_path__ + "static/media/about1.6600b809.svg";